// extracted by mini-css-extract-plugin
export default {"popup":"page-folds-option-module__popup--VTH6o"};